import React, { useState, useRef, useEffect } from 'react';

interface Language {
  lang: string;
  name: string;
  flag: string;
}

interface LanguageSelectorProps {
  languages: Language[];
  currentLanguageCode?: string;
  onLanguageChange?: (language: Language) => void;
  className?: string;
  buttonClassName?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  languages = [],
  currentLanguageCode = 'en',
  onLanguageChange,
  className = '',
  buttonClassName = 'btn-color-gray-700'
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const currentLanguage = languages.find(x => x.lang === currentLanguageCode);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (language: Language) => {
    setOpen(false);
    if (onLanguageChange) {
      onLanguageChange(language);
    }
  };

  return (
    <div className={`me-10 ${className}`} ref={containerRef} style={{ position: 'relative' }}>
      <button
        type="button"
        className={`btn btn-flex btn-link btn-active-color-primary rotate fs-base ${buttonClassName}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <img
          className="w-20px h-20px rounded me-3"
          src={currentLanguage?.flag}
          alt=""
        />
        <span className="me-1">
          {currentLanguage?.name}
        </span>
        <span className={`d-flex flex-center ${open ? 'rotate-180' : ''}`} style={{ transition: 'transform 0.2s' }}>
          <i className="ki-duotone ki-down fs-5 text-muted m-0"></i>
        </span>
      </button>

      {open && (
        <div
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-4 fs-7 show"
          style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1000 }}
        >
          {languages.map((item, index) => (
            <div key={`lang_${index}`} className="menu-item px-3">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                className="menu-link d-flex px-5"
                onClick={(e) => {
                  e.preventDefault();
                  handleLanguageChange(item);
                }}
              >
                <span className="symbol symbol-20px me-4">
                  <img
                    className="rounded-1"
                    src={item.flag}
                    alt=""
                  />
                </span>
                <span>{item.name}</span>
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
